export class SocketEvent {
  /**
   * @param {any} data
   * @param {any} context
   */
  async handle(data, context) {
    throw new Error('Handler must implement handle()')
  }
}
